import { render, staticRenderFns } from "./TheGallery.vue?vue&type=template&id=134b90d2&scoped=true"
import script from "./TheGallery.vue?vue&type=script&lang=js"
export * from "./TheGallery.vue?vue&type=script&lang=js"
import style0 from "./TheGallery.vue?vue&type=style&index=0&id=134b90d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134b90d2",
  null
  
)

export default component.exports